import { ClientPageType } from 'src/app/types';

export const GTMPageType: Record<ClientPageType, string> = {
  [ClientPageType.HOME]: 'Homepage',
  [ClientPageType.CATEGORY]: 'category',
  [ClientPageType.LANDING]: 'landing page',
  [ClientPageType.LISTICLE]: 'listicle page',
  [ClientPageType.PDP]: 'product detail page',
  [ClientPageType.CART]: 'shopping cart',
  [ClientPageType.SEARCH_RESULT]: 'search result page',
  [ClientPageType.LONG_TAIL]: 'long tail page',
  [ClientPageType.CONTENT]: 'content page',
  [ClientPageType.CHECKOUT]: 'checkout page',
  [ClientPageType.WISHLIST]: 'wishlist page',
  [ClientPageType.FINDER]: 'finder page',
  [ClientPageType.THEME]: 'theme page',
};
